import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import {
  getSortedScores,
  getCsv,
  getError,
  getIsDownloadLoading,
  handleUpload,
  handleDownload
} from "containers/Deploy/reducer";

import { fetchAllDeployments, handleRestfulDeploy } from "containers/Deployments/reducer";

import ModelTileContainer from "containers/Tiles/ModelTile";

import Deploy from "components/Deploy/Deploy";

class DeployContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, model, modelId, handleUpload, handleDownload, handleRestfulDeploy, history } = this.props;

    return (
      <Deploy
        {...this.props}
        handleRestfulDeploy={(id, modelName) => handleRestfulDeploy(id, modelName)}
        handleDownload={(scoreId, modelId, url) => handleDownload(id, scoreId, modelId, url)}
        handleComplete={(response) => handleUpload(id, modelId, response)}
        handleBack={() => history.push("/create/" + id)}
        modelTile={<ModelTileContainer model={model} id={id} isNoClick={true} />}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init()),
  handleRestfulDeploy: (id, modelName) => dispatch(handleRestfulDeploy(id, modelName)),
  fetchAllDeployments: (id) => dispatch(fetchAllDeployments(id)),
  handleUpload: (id, modelId, response) => dispatch(handleUpload(id, modelId, response)),
  handleDownload: (id, scoreId, modelId, url) => dispatch(handleDownload(id, scoreId, modelId, url)),
  updateDeploy: (id, modelId) => dispatch(runReducer.updateDeploy(id, modelId))
});

const mapStateToProps = (state, ownProps) => {
  const id =
    ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.id ? ownProps.match.params.id : -1;

  const modelId =
    ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.modelId
      ? ownProps.match.params.modelId
      : -1;

  return {
    id: id,
    modelId: modelId,
    label: setupReducer.getLabel(state, id),
    accountId: runReducer.getJobAccountId(state, id),
    model: runReducer.getTransformedModelById(state, id, modelId),
    scores: getSortedScores(state, id, modelId),
    csv: getCsv(state, id, modelId),
    isDownloadLoading: getIsDownloadLoading(state, id, modelId),
    error: getError(state, id, modelId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DeployContainer);
